import { DASHBOARD_I18N_ES } from './dashboardKeys';

export default {
  'nav.progress': 'Progreso',
  'nav.mi_progreso': 'Mi Progreso',
  'nav.support': 'Soporte',
  'nav.home': 'Inicio',
  'nav.calculator': 'Calculadora',
  'nav.foods': 'Alimentos',
  'nav.myaccount': 'Mi Cuenta',
  'nav.foodsmanager': 'Alimentos',
  'nav.plans': 'Planes',
  'nav.users': 'Usuarios',
  'nav.admin': 'Admin',
  'nav.companies': 'Empresas',
  'nav.equivalentes': 'Equivalentes',
  'nav.recipes': 'Recetas',
  'auth.logout': 'Cerrar Sesión',
  'auth.login': 'Iniciar Sesión',
  'auth.logging_in': 'Iniciando sesión...',
  'auth.welcome': 'Bienvenido a',
  'auth.email': 'Correo Electrónico',
  'auth.email_placeholder': 'tu@email.com',
  'auth.password': 'Contraseña',
  'auth.remember_me': 'Recordar mi usuario',
  'auth.login_error': 'Error en el login',
  'auth.no_account': '¿No tienes cuenta?',
  'auth.register_free': 'Regístrate gratis',
  'welcome.title': 'Bienvenido, {name}!',
  'welcome.role': 'Rol',
  'card.calculator.title': '🧮 Calculadora Nutricional',
  'card.calculator.desc': 'Calcula tu plan personalizado basado en tus datos',
  'card.calculator.button': 'Ir a Calculadora',
  'card.admin.title': '⚙️ Administración',
  'card.admin.desc': 'Gestiona los conceptos de la calculadora',
  'card.admin.button': 'Panel Admin',
  'card.users.title': '👥 Usuarios y Roles',
  'card.users.desc': 'Consulta y ajusta los roles de usuarios',
  'card.users.button': 'Abrir Usuarios',
  'card.plans.title': '🧾 Planes de Suscripción',
  'card.plans.desc': 'Crea, edita y elimina planes',
  'card.plans.button': 'Gestionar Planes',
  'card.companies.title': '🏢 Empresas',
  'card.companies.desc': 'Consulta gimnasios, entrenadores y usuarios asociados',
  'card.companies.button': 'Abrir Empresas',
  'card.myplan.title': '📊 Mi Plan',
  'card.myplan.desc': 'Consulta tu plan de alimentación personalizado',
  'card.myplan.button': 'Ver Plan',
  'card.foodlog.title': '🍔 Registro de Comidas',
  'card.foodlog.desc': 'Registra lo que comiste hoy',
  'card.foodlog.button': 'Registrar Comida',
  'card.progress.title': '📈 Progreso',
  'card.progress.desc': 'Visualiza tu evolución',
  'card.progress.button': 'Ver Estadísticas',
  'card.equivalentes.title': '🔄 Equivalentes por Grupo',
  'card.equivalentes.desc': 'Intercambia alimentos manteniendo macros',
  'card.equivalentes.button': 'Ver Equivalentes',
  'card.recipes.title': '📚 Recetas',
  'card.recipes.desc': 'Explora recetas saludables',
  'card.recipes.button': 'Ver Recetas',
  'home.summary.title': 'Resumen del Día',
  'calculator.title': 'Calculadora Nutricional',
  'calculator.subtitle': 'Calcula tu plan personalizado',
  'calculator.age': 'Edad (años)',
  'calculator.weight': 'Peso (kg)',
  'calculator.height': 'Altura (cm)',
  'calculator.gender': 'Género',
  'calculator.male': 'Masculino',
  'calculator.female': 'Femenino',
  'calculator.activity': 'Nivel de Actividad',
  'calculator.goal': 'Objetivo',
  'calculator.maintenance': 'Mantenimiento',
  'calculator.fatloss': 'Pérdida de Grasa',
  'calculator.muscle': 'Ganancia Muscular',
  'calculator.calculate': 'Calcular Plan',
  'calculator.calculating': 'Calculando...',
  'calculator.result_title': 'Tu Plan Personalizado',
  'calculator.daily_calories': 'Calorías Diarias',
  'calculator.protein': 'Proteína',
  'calculator.carbs': 'Carbohidratos',
  'calculator.fats': 'Grasas',
  'calculator.tmb': 'TMB',
  'calculator.tdee': 'TDEE',
  'myaccount.current_subscription': 'Mi Suscripción Actual',
  'myaccount.no_active': 'No tienes una suscripción activa.',
  'myaccount.expires': 'Vence',
  'myaccount.gym': 'Sede',
  'myaccount.trainer': 'Entrenador',
  'myaccount.sessions_left': 'Sesiones Restantes',
  'myaccount.mydata': 'Mis Datos',
  'myaccount.birthdate': 'Fecha de Nacimiento',
  'myaccount.objective': 'Objetivo',
  'myaccount.save': 'Guardar Cambios',
  'myaccount.available_plans': 'Planes Disponibles',
  'myaccount.choose_plan': 'Elige tu plan',
  'myaccount.subscribe': 'Contratar',
  'myaccount.subscribe_plan': 'Contratar Plan',
  'myaccount.method': 'Método de Pago',
  'myaccount.confirm_and_pay': 'Confirmar y Pagar',
  'myaccount.confirm': 'Confirmar',
  'recipes.library_title': '📚 Biblioteca de Recetas',
  'recipes.search_ph': 'Buscar recetas (ej. Pollo, Keto...)',
  'recipes.search': 'Buscar',
  'recipes.loading': 'Cargando recetas...',
  'recipes.none': 'No se encontraron recetas.',
  'recipes.view': 'Ver Detalles',
  'recipes.ai_button': '🤖 Chef IA',
  'recipes.ai_title': '👨‍🍳 Chef Inteligente',
  'recipes.ai_type': 'Tipo de Comida',
  'recipes.ai_ingredients': 'Ingredientes disponibles (separados por coma)',
  'recipes.ai_prefs': 'Preferencias / Restricciones',
  'recipes.ai_generate': '✨ Generar Receta',
  'recipes.ai_cooking': '🍳 Cocinando idea...',
  'recipes.import_replace': 'Reemplazar biblioteca',
  'recipes.import_add': 'Agregar',
  'recipes.import_help': 'Pega una tabla con columnas: ID Receta, Nombre del Plato, Ingredientes Clave (IDs), Cal Totales, Proteína T, Carbos T, Grasas T. Se admiten secciones como "--Desayunos...---ID Receta..."',
  'recipes.import_ph': 'Pega aquí las recetas...',
  'recipes.import_parse_error': '❌ No se encontraron filas válidas.',
  'recipes.import_done': '✅ Recetas reemplazadas',
  'recipes.import_done_add': '✅ Recetas agregadas',
  'recipes.import_error': '❌ Error al importar recetas',
  'recipes.add_link_title': 'Agregar enlace de receta',
  'recipes.link_name': 'Nombre',
  'recipes.link_url': 'URL',
  'recipes.link_tags': 'Etiquetas (coma separadas)',
  'recipes.add_link': 'Agregar',
  'lang.label': 'Idioma',
  'lang.es': 'Español',
  'lang.en': 'Inglés',
  'admin.menu.users': 'Usuarios',
  'admin.menu.plans': 'Planes',
  'admin.menu.gyms': 'Gimnasios',
  'admin.menu.trainers': 'Entrenadores',
  'admin.menu.foods': 'Alimentos',
  'admin.menu.calculator': 'Calculadora',
  'admin.menu.payments': 'Pagos',
  'admin.menu.companies': 'Empresas',
  'admin.subtitle': 'Gestiona {section} y configuraciones del sistema.',
  'admin.view_site': 'Ver Sitio Web',
  'common.loading': 'Cargando...',
  'common.search': 'Buscar',
  'common.user': 'Usuario',
  'common.role': 'Rol',
  'common.plan': 'Plan',
  'common.close': 'Cerrar',
  'common.name': 'Nombre',
  'common.email': 'Email',
  'common.email_ph': 'juan@ejemplo.com',
  'common.create': 'Crear',
  'common.cancel': 'Cancelar',
  'common.none': 'Ninguno',
  'common.registration': 'Registro',
  'common.back': '← Volver',
  'common.saving': 'Guardando...',
  'common.city': 'Ciudad',
  'common.address': 'Dirección',
  'common.contact': 'Contacto',
  'common.actions': 'Acciones',
  'common.select': 'Seleccionar...',
  'common.change': 'Cambiar',
  'common.fullname': 'Nombre Completo',
  'common.fullname_ph': 'Ej. Juan Pérez',
  'common.phone': 'Teléfono',
  'common.phone_ph': '+34 600 000 000',
  'common.name_required': 'Nombre *',
  'common.description': 'Descripción',
  'common.gym': 'Gimnasio',
  'common.trainer': 'Entrenador',
  'common.save': 'Guardar',
  'common.edit': 'Editar',
  'common.delete': 'Eliminar',
  'common.id': 'ID',
  'meals.breakfast': 'Desayuno',
  'meals.lunch': 'Almuerzo',
  'meals.dinner': 'Cena',
  'meals.snack': 'Snack',
  'groups.all': 'Todas',
  'groups.protein': 'Proteínas',
  'groups.carbs': 'Carbohidratos',
  'groups.fats': 'Grasas',
  'foods.view_more': 'Ver más alimentos',
  'foods.scan': 'Escanear',
  'foods.stop_scan': 'Detener',
  'foods.quick_create': 'Crear alimento',
  'foods.create_food': 'Crear alimento',
  'foods.serving_ph': 'Porción (ej. 100)',
  'foodlog.title': 'Registro de Alimentos',
  'foodlog.subtitle': 'Añade tus comidas del día y controla tus metas',
  'foodlog.nutrition_plan': 'FOOD_PLAN',
  'foodlog.range_title': 'Rango de Fechas',
  'foodlog.start': 'Inicio',
  'foodlog.end': 'Fin',
  'foodlog.weekly_progress': 'Avance Semanal',
  'foodlog.no_range': 'Sin datos para el rango.',
  'foodlog.date': 'Fecha',
  'foodlog.summary_btn': 'Resumen de alimentos',
  'foodlog.select_meal': 'Selecciona la comida',
  'foodlog.assign_food': 'Asignar alimento',
  'foodlog.base_portion': 'Porción base',
  'foodlog.portions': 'Porciones (enteros)',
  'foodlog.meal': 'Comida',
  'foodlog.equals': 'Equivale a',
  'foodlog.add_to_log': 'Agregar al registro',
  'foodlog.no_records_meal': 'No hay registros para esta comida',
  'foodlog.no_records_in': 'Sin registros en',
  'foodlog.deleted_ok': '✅ Registro eliminado',
  'foodlog.delete_error': '❌ Error al eliminar registro',
  'foodlog.delete_confirm': '¿Estás seguro que deseas eliminar este registro?',
  'foodlog.portion_integer_error': 'La porción debe ser un entero mayor a 0',
  'foodlog.added_ok': '✅ Alimento agregado',
  'foodlog.save_error': '❌ Error al guardar',
  'foodlog.barcode_found': '✅ Producto encontrado por código de barras',
  'foodlog.barcode_not_found': '❌ No se encontró el producto. Puedes crearlo rápidamente aquí.',
  'foods.scan_unsupported': 'El lector no es compatible en este navegador. Usa la caja de código.',
  'foods.scan_error': 'Error leyendo el código. Intenta de nuevo.',
  'foods.camera_denied': 'No se pudo acceder a la cámara. Revisa permisos.',
  'foods.created_ok': '✅ Alimento creado',
  'foods.create_error': '❌ No tienes permisos o datos incompletos',
  'foods.form_required': '❌ Por favor completa todos los campos requeridos',
  'foods.updated_ok': '✅ Alimento actualizado exitosamente',
  'foods.save_error': '❌ Error al guardar alimento',
  'foods.delete_confirm': '¿Estás seguro que deseas eliminar este alimento?',
  'foods.deleted_ok': '✅ Alimento eliminado exitosamente',
  'foods.delete_error': '❌ Error al eliminar alimento',
  'foods.bulk_delete_no_code': 'Eliminar sin código',
  'foods.bulk_delete_confirm': '¿Eliminar todos los alimentos sin código de barras?',
  'foods.bulk_delete_done': 'Eliminación completada',
  'foods.bulk_delete_hint': 'Borra entradas sin código de barras',
  'foods.bulk_none': 'No hay alimentos sin código.',
  'foods.import_replace': 'Reemplazar catálogo',
  'foods.import_add': 'Agregar',
  'foods.import_replace_hint': 'Reemplaza el catálogo pegando una tabla',
  'foods.import_help': 'Pega una tabla con columnas: Código de Barras, Alimento, Categoría, Cal, Prot, Carb, Gras. Usaremos porción 100 g por defecto.',
  'foods.import_ph': 'Pega aquí los datos...',
  'foods.import_parse_error': '❌ No se encontraron filas válidas. Verifica el formato.',
  'foods.import_done': '✅ Importación completa',
  'foods.import_done_add': '✅ Datos agregados',
  'foods.import_error': '❌ Error al importar alimentos',
  'companies.error_loading': 'Error cargando datos',
  'companies.gyms': 'Gimnasios',
  'companies.trainers': 'Entrenadores',
  'companies.no_gyms': 'Sin gimnasios',
  'companies.no_trainers': 'Sin entrenadores',
  'companies.users_of_gym': 'Usuarios del Gimnasio: {name}',
  'companies.users_of_trainer': 'Usuarios del Entrenador: {name}',
  'companies.select_prompt': 'Selecciona un gimnasio o entrenador',
  'companies.new_user': 'Nuevo usuario',
  'companies.password_optional': 'Contraseña (opcional)',
  'companies.no_plan': 'Sin plan',
  'companies.no_assigned': 'No hay usuarios asociados',
  'users.title': 'Usuarios',
  'users.subtitle': 'Gestiona usuarios y configuraciones del sistema.',
  'users.tabs.users': 'Usuarios',
  'users.tabs.gyms': 'Gimnasios',
  'users.tabs.trainers': 'Entrenadores',
  'users.new_user': 'Nuevo Usuario',
  'users.edit_user': 'Editar Usuario',
  'users.create_user': 'Crear Nuevo Usuario',
  'users.error_loading': 'Error cargando usuarios',
  'users.loading': 'Cargando usuarios...',
  'users.none': 'No hay usuarios registrados.',
  'users.none_search': 'No hay resultados para tu búsqueda.',
  'users.search_ph': 'Buscar por nombre, email, ID, rol, gimnasio o entrenador...',
  'users.search_aria': 'Buscar personas',
  'users.list_title': 'Listado de personas',
  'users.search_count': '{shown} de {total}',
  'users.total_count': '{total} registrados',
  'users.email_exists': 'Este email ya está registrado',
  'users.gyms_summary': 'Resumen de Gimnasios',
  'users.trainers_summary': 'Resumen de Entrenadores',
  'users.view_users': 'Ver usuarios',
  'users.no_assigned': 'No hay usuarios asociados.',
  'users.new_password_prompt': 'Nueva contraseña (mín. 6 caracteres):',
  'users.password_min': 'La contraseña debe tener al menos 6 caracteres',
  'users.password_updated': 'Contraseña actualizada',
  'users.password_update_error': 'Error actualizando contraseña',
  'users.reset_password': 'Resetear contraseña',
  'users.reset_password_short': 'Reset Clave',
  'users.delete_confirm': '¿Estás seguro de eliminar este usuario?',
  'users.delete_error': 'Error al eliminar usuario',
  'calculator.admin.title': 'Gestión de Conceptos de Calculadora',
  'calculator.admin.subtitle': 'Factores de actividad y reglas para el cálculo.',
  'calculator.toggle_add': '+ Agregar Concepto',
  'calculator.toggle_cancel': 'Cancelar',
  'calculator.form.name': 'Nombre',
  'calculator.form.type': 'Tipo',
  'calculator.form.select_type': 'Selecciona tipo',
  'calculator.form.value': 'Valor',
  'calculator.form.description': 'Descripción',
  'calculator.type.activity': 'Factor Actividad',
  'calculator.type.macro': 'Distribución Macros',
  'calculator.type.other': 'Otro',
  'calculator.saving': 'Guardando...',
  'calculator.create': 'Crear',
  'calculator.update': 'Actualizar',
  'calculator.table.name': 'Nombre',
  'calculator.table.type': 'Tipo',
  'calculator.table.value': 'Valor',
  'calculator.table.description': 'Descripción',
  'calculator.table.actions': 'Acciones',
  'calculator.edit': 'Editar',
  'calculator.delete': 'Eliminar',
  'calculator.created': 'Concepto creado',
  'calculator.updated': 'Concepto actualizado',
  'calculator.deleted': 'Concepto eliminado',
  'calculator.delete_confirm': '¿Eliminar este concepto?',
  'calculator.save_error': 'Error guardando concepto',
  'plans.subscription': 'Plan de Suscripción',
  'plans.title': 'Planes de Suscripción',
  'plans.new': 'Nuevo Plan',
  'plans.edit': 'Editar Plan',
  'plans.create': 'Crear Nuevo Plan',
  'plans.name': 'Nombre del Plan',
  'plans.monthly_price': 'Precio Mensual (COP)',
  'plans.max_users': 'Máximo de Usuarios',
  'plans.features': 'Características (separadas por coma)',
  'plans.features_ph': 'Ej: Acceso 24/7, Entrenador Personal',
  'plans.save': 'Guardar Plan',
  'plans.price': 'Precio',
  'plans.capacity': 'Cupo Máx',
  'plans.active': 'Activos',
  'plans.loading': 'Cargando planes...',
  'plans.none': 'No hay planes disponibles. Crea uno nuevo.',
  'plans.error_loading': 'Error cargando planes',
  'plans.delete_confirm': '¿Seguro que deseas eliminar este plan?',
  'plans.delete_error': 'Error al eliminar plan',
  'gyms.error_loading': 'Error cargando gimnasios',
  'gyms.updated': 'Gimnasio actualizado correctamente',
  'gyms.created': 'Gimnasio creado exitosamente',
  'gyms.save_error': 'Error al guardar gimnasio',
  'gyms.delete_confirm': '¿Estás seguro de eliminar este gimnasio?',
  'gyms.deleted': 'Gimnasio eliminado correctamente',
  'gyms.delete_error': 'Error al eliminar gimnasio',
  'gyms.plan_assigned': 'Plan asignado correctamente',
  'gyms.assign_error': 'Error al asignar plan',
  'gyms.title': 'Gestión de Gimnasios',
  'gyms.subtitle': 'Administra las sedes y ubicaciones',
  'gyms.new': 'Nuevo Gimnasio',
  'gyms.search_ph': 'Buscar por nombre, ciudad o dirección...',
  'gyms.edit': 'Editar Gimnasio',
  'gyms.create': 'Crear Nuevo Gimnasio',
  'gyms.name': 'Nombre del Gimnasio',
  'gyms.name_ph': 'Ej: Smart Fit Centro',
  'gyms.city_ph': 'Ej: Bogotá',
  'gyms.address_ph': 'Ej: Calle 123 # 45-67',
  'gyms.contact_email': 'Email Contacto',
  'gyms.email_ph': 'Ej: contacto@gimnasio.com',
  'gyms.loading': 'Cargando gimnasios...',
  'gyms.none': 'No se encontraron gimnasios',
  'gyms.none_help': 'Intenta ajustar tu búsqueda o crea un nuevo gimnasio.',
  'gyms.location': 'Ubicación',
  'trainers.error_loading': 'Error cargando entrenadores',
  'trainers.save_error': 'Error al guardar entrenador',
  'trainers.delete_confirm': '¿Estás seguro de eliminar este entrenador?',
  'trainers.delete_error': 'Error al eliminar entrenador',
  'trainers.title': 'Gestión de Entrenadores',
  'trainers.subtitle': 'Administra el equipo de entrenadores y sus asignaciones',
  'trainers.new': 'Nuevo Entrenador',
  'trainers.edit': 'Editar Entrenador',
  'trainers.list': 'Lista de Entrenadores',
  'trainers.search_ph': 'Buscar entrenador...',
  'trainers.trainer': 'Entrenador',
  'trainers.specialty': 'Especialidad',
  'trainers.specialty_ph': 'Ej. Musculación, Yoga, Crossfit',
  'trainers.assigned_gym': 'Gimnasio Asignado',
  'trainers.select_gym': 'Seleccione un gimnasio',
  'trainers.save': 'Guardar Entrenador',
  'trainers.loading': 'Cargando entrenadores...',
  'trainers.none': 'No se encontraron entrenadores',
  'trainers.general': 'General',
  'trainers.gym_id': 'Gimnasio ID: ',
  'trainers.unassigned': 'Sin asignar',
  'trainers.showing': 'Mostrando {shown} de {total} entrenadores',
  'foods.title': 'Catálogo de Alimentos',
  'foods.subtitle': 'Administra el catálogo de alimentos con valores nutricionales.',
  'foods.new': 'Nuevo Alimento',
  'foods.edit': 'Editar Alimento',
  'foods.create': 'Crear Nuevo Alimento',
  'foods.name_ph': 'Ej: Pechuga de Pollo',
  'foods.barcode': 'Código de Barras',
  'foods.barcode_ph': 'Escanear o escribir código...',
  'foods.category_required': 'Categoría *',
  'foods.select_category': 'Seleccionar categoría',
  'foods.brand': 'Marca',
  'foods.brand_ph': 'Ej: Genérica',
  'foods.amount_required': 'Cantidad *',
  'foods.unit_required': 'Unidad *',
  'foods.unit_g': 'Gramos (g)',
  'foods.unit_ml': 'Mililitros (ml)',
  'foods.unit_unidad': 'Unidad',
  'foods.unit_tbsp': 'Cucharada',
  'foods.unit_cup': 'Taza',
  'foods.nutrients_title': 'Valores Nutricionales por Porción',
  'foods.calories': 'Calorías',
  'foods.protein': 'Proteína (g)',
  'foods.carbs': 'Carbohidratos (g)',
  'foods.fats': 'Grasas (g)',
  'foods.search_ph': 'Buscar alimento...',
  'foods.all_categories': 'Todas las categorías',
  'foods.code': 'Código',
  'foods.food': 'Alimento',
  'foods.category': 'Categoría',
  'foods.serving': 'Porción',
  'foods.cal': 'Cal',
  'foods.protein_short': 'Proteína',
  'foods.carbs_short': 'Carbos',
  'foods.fats_short': 'Grasas',
  'foods.generic': 'Genérica',
  'foods.none': 'No se encontraron alimentos',
  'foods.total': 'Total:',
  'foods.items': 'alimentos',
  'progress.title': 'Progreso',
  'progress.subtitle': 'Seguimiento y recomendaciones',
  'progress.kpis': 'KPIs del Rango',
  'progress.avg_adherence': 'Cumplimiento promedio',
  'progress.avg_calories': 'Calorías promedio',
  'progress.avg_protein': 'Proteína promedio',
  'progress.avg_carbs': 'Carbohidratos promedio',
  'progress.avg_fats': 'Grasas promedio',
  'progress.range_filters': 'Rango y Filtros',
  'progress.start': 'Inicio',
  'progress.end': 'Fin',
  'progress.gym': 'Gimnasio',
  'progress.trainer': 'Entrenador',
  'progress.all': 'Todos',
  'progress.by_day': 'Avance por Día',
  'progress.no_data_range': 'Sin datos en el rango',
  'progress.quick_summary': 'Resumen Rápido',
  'progress.days_in_range': 'Días en rango',
  'progress.agg': 'Agregados',
  'progress.selected_gym': 'Gimnasio seleccionado',
  'progress.selected_trainer': 'Entrenador seleccionado',
  'progress.kcal_in_range': 'kcal en rango',
  'progress.analytics_groups': 'Analítica por Grupos',
  'progress.gyms': 'Gimnasios',
  'progress.trainers': 'Entrenadores',
  'progress.export_both': 'Exportar ambos CSV',
  'progress.page_size': 'Tamaño página',
  'progress.gym_name_ph': 'Nombre de gimnasio',
  'progress.trainer_name_ph': 'Nombre de entrenador',
  'progress.clear': 'Limpiar',
  'progress.export_csv': 'Exportar CSV',
  'progress.compliance_short': 'Cumpl.',
  'progress.kcal': 'Kcal',
  'progress.page': 'Página',
  'progress.of': 'de',
  'progress.prev': 'Anterior',
  'progress.next': 'Siguiente',
  'progress.weekly_trend': 'Tendencia semanal',
  'progress.no_recent_data': 'Sin datos recientes',
  'ai.title': '🤖 Asistente Nutricional IA',
  'ai.toggle_on': '🔴 IA Activada',
  'ai.toggle_off': '⚪ Modo Rápido',
  'ai.analysis_title': '📊 Análisis de tu día',
  'ai.calories': 'Calorías',
  'ai.protein': 'Proteína',
  'ai.carbs': 'Carbohidratos',
  'ai.fats': 'Grasas',
  'ai.missing': 'Faltante:',
  'ai.loading': 'Generando sugerencias personalizadas...',
  'ai.recommendations': '💡 Recomendaciones para Completar tu Meta',
  'ai.portion': 'Porción recomendada:',
  'ai.refresh': '🔄 Actualizar Sugerencias',
  'ai.message_ok': '✅ ¡Excelente! Ya cumpliste tus metas del día',
  'ai.message_quick': '🤖 Sugerencias basadas en análisis (modo rápido)',
  'ai.message_generic': '📋 Sugerencias personalizadas',
  'ai.error_loading': '❌ Error al cargar sugerencias',
  'ai.goal_maintenance': 'Mantenimiento',
  'equivalentes.title': 'Equivalentes por Grupo',
  'equivalentes.subtitle': 'Intercambia alimentos manteniendo macros aproximados.',
  'equivalentes.base': 'Base',
  'equivalentes.error_loading': 'No fue posible cargar equivalentes. Intenta más tarde.',
  ...DASHBOARD_I18N_ES,
};
